import { Array, Boolean, Literal, Number, Optional, Record, Static, String, Undefined, Union } from 'runtypes';

const IdoFieldReadOnlyRunType = Literal('true').Or(Literal('false')).Or(Boolean);
const IdoFieldWidthRunType = Number.Or(String);

const IdoFieldContactPersonValuesRunType = Record({
	display: String,
	value: String,
});

export const IdoFieldContactPersonRunType = Record({
	emptyText: String,
	label: String,
	name: Literal('NETZkultur_IdoModel_FieldTypes_ContactPerson_'),
	selectedValue: String,
	type: Literal('contactPerson'),
	values: Array(IdoFieldContactPersonValuesRunType),
});

export type IdoFieldContactPerson = Static<typeof IdoFieldContactPersonRunType>;

export const IdoFieldLastContactDateRunType = Record({
	format: String,
	label: String,
	name: Literal('NETZkultur_IdoModel_FieldTypes_LastContactDate_'),
	type: Literal('datefield'),
	value: String,
	width: Number,
});

export type IdoFieldLastContactDate = Static<typeof IdoFieldLastContactDateRunType>;

export const IdoFieldSingleChoiceValueRunType = Record({
	display: String,
	value: String,
});

export type IdoFieldSingleChoiceValue = Static<typeof IdoFieldSingleChoiceValueRunType>;

export const IdoFieldSingleChoiceRunType = Record({
	columns: String,
	emptyText: String,
	label: String,
	name: String,
	readOnly: IdoFieldReadOnlyRunType,
	selectedValue: Optional(Union(String, Undefined)),
	type: Literal('singleChoiceSelect').Or(Literal('singleChoiceRadio')),
	values: Optional(Array(IdoFieldSingleChoiceValueRunType).Or(Undefined)),
	vertical: Literal('true').Or(Literal('false')),
	width: Optional(IdoFieldWidthRunType),
});

export type IdoFieldSingleChoice = Static<typeof IdoFieldSingleChoiceRunType>;

export const IdoFieldMultipleChoiceValueRunType = Record({
	display: String,
	value: String,
});

export type IdoFieldMultipleChoiceValue = Static<typeof IdoFieldMultipleChoiceValueRunType>;

export const IdoFieldMultipleChoiceRunType = Record({
	emptyText: String,
	label: String,
	name: String,
	readOnly: IdoFieldReadOnlyRunType,
	selectedValues: Optional(Array(String)),
	type: Literal('multiplechoice').Or(Literal('multiplechoiceTag')),
	values: Optional(Array(IdoFieldMultipleChoiceValueRunType)),
	width: Optional(String),
});

export type IdoFieldMultipleChoice = Static<typeof IdoFieldMultipleChoiceRunType>;

export const IdoFieldNextContactDateRunType = Record({
	format: String,
	label: String,
	name: String,
	type: Literal('datefield'),
	value: String,
	width: Number,
});

export type IdoFieldNextContactDate = Static<typeof IdoFieldNextContactDateRunType>;

const IdoFieldNextContactTimeCheckboxValuesRunType = Record({
	display: String,
	value: String,
});

export const IdoFieldNextContactTimeCheckboxRunType = Record({
	label: String,
	name: String,
	selectedValues: Array(String),
	type: Literal('checkboxgroup'),
	values: Array(IdoFieldNextContactTimeCheckboxValuesRunType),
});

export type IdoFieldNextContactTimeCheckbox = Static<typeof IdoFieldNextContactTimeCheckboxRunType>;

export const IdoFieldNextContactTimeRunType = Record({
	increment: Number,
	label: String,
	maxValue: String,
	minValue: String,
	name: String,
	type: Literal('timefield'),
	value: String,
	width: Number,
});

export type IdoFieldNextContactTime = Static<typeof IdoFieldNextContactTimeRunType>;

export const IdoFieldTextAreaRunType = Record({
	label: String,
	name: String,
	type: Literal('textarea'),
	value: String,
});

export type IdoFieldTextArea = Static<typeof IdoFieldTextAreaRunType>;

export const IdoFieldValueMailActionRunType = Record({
	actionCls: Literal('fa-envelope'),
	label: String,
	name: String,
	readOnly: IdoFieldReadOnlyRunType,
	type: Literal('textField'),
	value: String,
	width: Optional(IdoFieldWidthRunType),
});

export type IdoFieldValueMailAction = Static<typeof IdoFieldValueMailActionRunType>;

export const IdoFieldValuePhoneActionRunType = Record({
	actionCls: Literal('fa-phone'),
	label: String,
	name: String,
	readOnly: IdoFieldReadOnlyRunType,
	type: Literal('textField'),
	value: String,
	width: Optional(IdoFieldWidthRunType),
});

export type IdoFieldValuePhoneAction = Static<typeof IdoFieldValuePhoneActionRunType>;

export const IdoFieldValueFaxActionRunType = Record({
	actionCls: Literal('fa-print'),
	label: String,
	name: String,
	readOnly: IdoFieldReadOnlyRunType,
	type: Literal('textField'),
	value: String,
	width: Optional(IdoFieldWidthRunType),
});

export type IdoFieldValueFaxAction = Static<typeof IdoFieldValueFaxActionRunType>;

export const IdoFieldValueLinkActionRunType = Record({
	actionCls: Literal('fa-link'),
	label: String,
	name: String,
	readOnly: IdoFieldReadOnlyRunType,
	type: Literal('textField'),
	value: String,
	width: Optional(IdoFieldWidthRunType),
});

export type IdoFieldValueLinkAction = Static<typeof IdoFieldValueLinkActionRunType>;

export const IdoFieldValueRunType = Record({
	label: String,
	name: String,
	readOnly: IdoFieldReadOnlyRunType,
	type: Literal('textField'),
	value: String,
	width: Optional(IdoFieldWidthRunType),
});

export type IdoFieldValue = Static<typeof IdoFieldValueRunType>;
